<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-col :span="2">
          <el-select v-model="pages.only_show_plan" placeholder="点单类型" style="width:100%;">
            <el-option
              key="0"
              label="全部订单"
              value="0">
            </el-option>
            <el-option
              key="1"
              label="预点单"
              value="1">
            </el-option>
            <el-option
              key="2"
              label="非预点单"
              value="2">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin-left: 10px">
          <el-select v-model="pages.sure_order" placeholder="确单状态" style="width:100%;">
            <el-option
              key="0"
              label="全部订单"
              value="0">
            </el-option>
            <el-option
              key="1"
              label="待确认"
              value="1">
            </el-option>
            <el-option
              key="2"
              label="已确认"
              value="2">
            </el-option>
            <el-option
              key="3"
              label="已拒绝"
              value="3">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin-left: 10px">
          <el-select v-model="pages.payStatus" placeholder="全部状态" style="width:100%;">
            <el-option
              v-for="item in status"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" style="margin-left: 10px">
          <el-input placeholder="请输入订单号/餐桌号查询" v-model="pages.keyword" class="input-with-select">
          </el-input>
        </el-col>

        <el-col :span="2" style="margin-left: 10px">
          <el-date-picker
            style="width:100%;"
            v-model="pages.created_start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间">
          </el-date-picker>
        </el-col>
        <el-col :span="2" style="margin-left: 10px">
          <el-date-picker
            style="width:100%;"
            v-model="pages.created_end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间">
          </el-date-picker>
        </el-col>
        <el-col :span="6" style="margin-left: 10px">
          <el-button @click="initData">搜索</el-button>
          <el-button type="primary" @click="exportExcel">导出订单</el-button>
        </el-col>

      </el-row>
      <br/>

      <el-table
        :data="orderData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          label="订单号"
          prop="orderNo">

        </el-table-column>
        <el-table-column
          label="餐桌编号">
          <template slot-scope="scope">
            <span v-if="scope.row.plan" style="color: red">预点<br/>用餐时间：{{ scope.row.startTime }}<br></span>

            <span v-else style="color: green">{{ scope.row.tableNumber }}<br></span>

            <span style="color: green" v-if="scope.row.getOrderNumber != null">取餐码：{{ scope.row.getOrderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付状态">
          <template slot-scope="scope">
            <span v-if="scope.row.payStatus == 1" style="color: blue">待支付</span>
            <span v-else-if="scope.row.payStatus == 2" style="color: green">已支付</span>
            <span v-else-if="scope.row.payStatus == 3" style="color: crimson">部分退款</span>
            <span v-else-if="scope.row.payStatus == 4" style="color: red">全部退款</span>
            <span v-else-if="scope.row.payStatus == 5" style="color: red">已取消</span>
          </template>
        </el-table-column>
        <el-table-column
          label="确认状态">
          <template slot-scope="scope">
            <span v-if="scope.row.applyStatus == 1" style="color: blue">待确认</span>
            <span v-else-if="scope.row.applyStatus == 2" style="color: green">已确认</span>
            <span v-else-if="scope.row.applyStatus == 3" style="color: crimson">已拒绝</span>
          </template>
        </el-table-column>
        <el-table-column
          label="金额(￥)"
          :formatter="realPriceFormat">
        </el-table-column>
        <el-table-column
          label="创建者"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="blacklist( scope.row)">
              <span v-if="scope.row.consumer != null">{{ scope.row.consumer.nickName }}</span>
              <span v-else>{{ scope.row.createdUser.account }}</span>

            </el-button>
          </template>
        </el-table-column>


        <el-table-column label="操作" width="480">
          <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleInfo(scope.row)">
                详情
              </el-button>
              <el-button
                size="mini"
                v-if="scope.row.payStatus == 1"
                @click="sureOrderHandlerAlert(scope.row)">
                确单
              </el-button>
              <el-button
                size="mini"
                v-if="scope.row.payStatus == 1 && scope.row.applyStatus != 3"
                @click="handleEditRealPrice(scope.row)">
                改价
              </el-button>
              <el-button
                size="mini"
                @click="openChoosePrinter(scope.row)"
                v-if="scope.row.applyStatus != 3 && scope.row.payStatus < 5"
              >
                打印
              </el-button>


              <el-button
                size="mini"
                type="danger"
                v-if="scope.row.payStatus != 2"
                @click="handleDeleteAlert( scope.row)">
                删除
              </el-button>
              <el-button
                size="mini"
                type="danger"
                v-if="scope.row.payStatus != 5"
                @click="handleCancelAlert( scope.row)">
                取消
              </el-button>
            <payments  v-if="scope.row.payStatus == 1 && scope.row.applyStatus == 2" btnName="支付"
                      :order="scope.row"
                       @paySuccess="paySuccess"
                       style="margin-top: 10px"></payments>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.page"
          :page-size="pages.pageSize"
          layout="total, prev, pager, next"
          :total="pages.total">
        </el-pagination>
      </div>
      <el-dialog title="打印" :visible.sync="printerDialogTableVisible">
        <el-divider content-position="left">打印机</el-divider>
        <div v-if="printerNodes.length > 0">
          <div v-for="(printerNode,key1) in printerNodes" :key="key1" style="margin: 5px">
            <el-radio v-model="choosePrinter" :label="item" border v-for="(item,key) in printerNode.printers"
                      :key="key">{{ item.name }}({{item.onlineStatusStr}})--<span style="color: #1ab2ff;">{{ printerNode.name }}</span></el-radio>
          </div>
        </div>
        <div v-else>
          暂无打印机
        </div>

        <span slot="footer" class="dialog-footer">
                <el-button @click="printerDialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="printOrder" v-if="choosePrinter != null">确 定</el-button>
              </span>
      </el-dialog>


      <el-dialog title="确认订单" :visible.sync="sureOrderDialogVisible"
                 width="30%">
        <span>为防止恶意刷单，请确认当前订单是否有效,如发现有人恶意刷单，可点击列表中的【创建者】的帐号将其加入黑名单</span>
        <br/>
        <br/>
        <el-select v-model="sureOrder.status" placeholder="请选择">
          <el-option
            v-for="item in sureOrderStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
              <el-button @click="sureOrderDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="sureOrderHandler">确 定</el-button>
            </span>
      </el-dialog>





    </div>
  </div>
</template>

<script>
import payments from './components/payments.vue';

export default {
  components: {
    payments
  },
  data() {
    return {
      baseUrl: window.server.baseUrl,
      loading: false,
      order: {},
      dialog: {
        dialogFormVisible: false,
        title: "新增餐桌",
        close: false,
      },
      pages: {
        offset: 0,
        pageSize: 10,
        page: 1,
        total: 0,
        payStatus: 0,
        keyword: "",
        created_start_time: "",
        created_end_time: "",
        only_show_plan: "0",
        sure_order: "0"
      },
      orderData: [],
      status: [
        {id: 0, name: "全部状态"},
        {id: 1, name: "待支付"},
        {id: 2, name: "已支付"},
        {id: 3, name: "部分退款"},
        {id: 4, name: "全部退款"},
        {id: 5, name: "已取消"},
      ],
      choosePrinter: {},
      printerNodes: [],
      printerDialogTableVisible: false,
      sureOrder: {
        order_id: 0,
        status: "2",
      },
      sureOrderDialogVisible: false,
      sureOrderStatus: [{
        value: '2',
        label: '确定为有效订单'
      }, {
        value: '3',
        label: '拒绝接受该订单'
      }],
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.loading = true;
      var that = this;
      that.$api.get('/store/orders', that.pages, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.orderData = res.data.orders.content;
            that.pages.total = res.data.orders.totalElements;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pages.page = val;
      this.pages.offset = (val - 1) * this.pages.pageSize;
      this.initData()
    },
    paySuccess(){
      this.$message({
        message: "订单支付成功",
        type: 'success'
      });
      this.initData()
    },
    handleInfo(row) {
      this.$router.push({path: '/store/orderDetail', query: {order_id: row.id}});
    },

    handleEditRealPrice(row) {
      var that = this;
      this.$prompt('请输入实收金额', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        that.$api.put('/store/orders/' + row.id, {real_price: value * 100}, response => {
          if (response.status >= 200 && response.status < 300) {
            var res = response.data;
            if (res.code == 0) {
              this.$message({
                message: "改价成功",
                type: 'success'
              });
              that.initData();
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: "服务器维护中",
              type: 'error'
            });
            this.initData();
          }
          this.loading = false;
        });

      }).catch(() => {

      });
    },

    openChoosePrinter(row) {
      this.order = row;
      var that = this;
      that.$api.get('/store/printer_data_model', null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.printerNodes = res.data.printerNodes;
            that.printerNodes.forEach(function (value, i) {
              if (value.printers != null && value.printers.length > 0) {
                value.printers.forEach(function (value2, i2) {
                  value2.node_id = value.id;
                  value2.node_name = value.name;
                });
              }
            });
            this.printerDialogTableVisible = true;
            this.choosePrinter = null;
            console.log(that.printerNodes);
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },

    printOrder() {
      var that = this;
      that.$api.put('/store/printer/' + that.choosePrinter.node_id + "/" + that.choosePrinter.id + '/order/' + this.order.id, null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: "已加入到打印队列了",
              type: 'success'
            });
            that.printerDialogTableVisible = false;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },


    exportExcel() {
      if (this.pages.created_start_time == "" || this.pages.created_end_time == "") {
        this.$message({
          message: "导出订单请先选择时间区间",
          type: 'warning'
        });
        return;
      }
      var storage = window.localStorage;
      var accessToken = storage["access_token"];
      location.href = this.baseUrl + "/store/orders/excel?access_token=" + accessToken + "&keyword=" + this.pages.keyword + "&status=" + this.pages.payStatus + "&created_start_time=" + this.pages.created_start_time + "&created_end_time=" + this.pages.created_end_time;
    },

    realPriceFormat(row, column) {
      if ((row.realPrice - row.refundPrice) == row.totalPrice) {
        return row.realPrice / 100 + "元";
      } else if (row.refundPrice == 0) {
        return "实收:" + row.realPrice / 100 + "元/总价:" + row.totalPrice / 100 + "元";
      } else {
        return "实收:" + row.realPrice / 100 + "元/退款" + row.refundPrice / 100 + "元/总价:" + row.totalPrice / 100 + "元";
      }

    },
    applyStatusFormat(row, column) {
      if (row.applyStatus == 1) {
        return "待确认";
      } else if (row.applyStatus == 2) {
        return "已确认";
      } else {
        return "已拒绝";
      }
    },

    blacklist(row) {
      this.loading = true;
      var that = this;
      that.$api.get('/store/blacklist', {user_id: row.createdUser.id}, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0 && res.data.blacklists.content.length > 0) {
            this.$confirm('要将该用户移出黑名单吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              that.$api.delete('/store/blacklist', {user_id: row.createdUser.id}, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: "移出成功,该用户可正常在本店下单",
                      type: 'success'
                    });

                  } else {
                    this.$message({
                      message: res.msg,
                      type: 'error'
                    });
                  }

                  this.loading = false;
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });

                  this.loading = false;
                }
              });

            }).catch(() => {

            });
          } else {
            this.$confirm('要将该用户加入黑名单吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.$api.post('/store/blacklist', {user_id: row.createdUser.id}, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: "加入成功,该用户将无法在本店下单",
                      type: 'success'
                    });
                  } else {
                    this.$message({
                      message: res.msg,
                      type: 'error'
                    });
                  }

                  this.loading = false;
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });

                  this.loading = false;
                }
              });

            }).catch(() => {

            });

            this.loading = false;
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });

          this.loading = false;
        }
      });
    },
    sureOrderHandlerAlert(row) {
      this.sureOrder.id = row.id;
      var status = row.applyStatus == 1 ? "2" : "" + row.applyStatus;
      this.sureOrder.status = status;
      this.sureOrderDialogVisible = true;
    },
    sureOrderHandler() {//确单操作
      var that = this;
      that.$api.put('/store/orders/' + this.sureOrder.id + "/status", {applyStatus: this.sureOrder.status}, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: "已更新当前订单状态",
              type: 'success'
            });
            this.sureOrderDialogVisible = false;
            this.initData();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },
    handleDeleteAlert(row) {
      this.$confirm('此操作将删除该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(row);
      }).catch(() => {

      });
    },
    handleDelete(row) {
      this.loading = true;
      var that = this;
      that.$api.delete('/store/orders/' + row.id, null, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.initData();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });

            this.loading = false;
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });

          this.loading = false;
        }

      });
    },

    handleCancelAlert(row) {
      this.$confirm('此操作将取消该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleCancel(row);
      }).catch(() => {

      });
    },
    handleCancel(row) {
      this.loading = true;
      var that = this;
      that.$api.put('/store/orders/cancel/' + row.id, null, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: '取消成功',
              type: 'success'
            });
            this.initData();
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });

            this.loading = false;
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });

          this.loading = false;
        }

      });
    },


  },
}
</script>

<style lang="less">
@import '../../style/mixin';

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.table_container {
  padding: 20px;
  text-align: left;
}

.Pagination {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/Orders.vue